/* Thrive Brew — preview interactions.
   Every behaviour here maps 1:1 to a Liquid section's JS in the ported theme. */
(function () {
  "use strict";

  /* ---- scroll reveals ---- */
  var rv = document.querySelectorAll(".rv");
  if ("IntersectionObserver" in window && rv.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---- sticky header shadow ---- */
  var hdr = document.querySelector(".hdr");
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle("is-stuck", window.scrollY > 12); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- mobile nav ---- */
  var burger = document.querySelector(".burger"), nav = document.querySelector(".nav");
  if (burger && nav) {
    burger.addEventListener("click", function () {
      var open = nav.classList.toggle("open");
      burger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  /* ---- signature moment: flavour switcher ---- */
  var fx = document.querySelector("[data-fx]");
  if (fx) {
    var tabs = fx.querySelectorAll(".fx__tab");
    var panels = fx.querySelectorAll(".fx__panel");
    var shots = fx.querySelectorAll(".fx__stage img");
    var pick = function (i) {
      tabs.forEach(function (t, n) { t.setAttribute("aria-selected", n === i ? "true" : "false"); });
      panels.forEach(function (p, n) { p.classList.toggle("on", n === i); });
      shots.forEach(function (s, n) { s.classList.toggle("on", n === i); });
      fx.style.setProperty("--fc", tabs[i].dataset.color);
    };
    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { pick(i); });
      t.addEventListener("mouseenter", function () { pick(i); });
    });
    pick(0);
  }

  /* ---- PDP variant selector ---- */
  document.querySelectorAll("[data-variants]").forEach(function (root) {
    var scope = root.closest(".pdp__g") || document;
    var btns = root.querySelectorAll(".vopt__btn");
    var priceEl = scope.querySelector("[data-pricebox]");
    var perCanEl = scope.querySelector("[data-percan]");
    var atc = scope.querySelector("[data-atc]");
    var noteEl = root.querySelector("[data-vnote]");
    var choose = function (b) {
      btns.forEach(function (x) { x.setAttribute("aria-selected", x === b ? "true" : "false"); });
      var price = parseFloat(b.dataset.price), cans = parseInt(b.dataset.cans, 10);
      var inv = parseInt(b.dataset.inv, 10);
      if (priceEl) priceEl.textContent = "$" + price.toFixed(2).replace(/\.00$/, "");
      if (perCanEl && cans) perCanEl.textContent = "$" + (price / cans).toFixed(2) + " per can · " + cans + " cans";
      if (atc && !document.querySelector("[data-mixer]")) {
        var out = inv <= 0;
        atc.classList.toggle("is-out", out);
        atc.textContent = out ? "Sold out" : "Add to cart";
        atc.disabled = out;
      }
      if (noteEl) {
        noteEl.textContent = inv <= 0 ? "This size is out of stock — the 12-pack is ready to ship."
          : (inv <= 6 ? "Only " + inv + " left in stock." : "In stock · ships this Wednesday.");
      }
    };
    btns.forEach(function (b) {
      b.addEventListener("click", function () { if (!b.disabled) choose(b); });
    });
    var first = root.querySelector(".vopt__btn:not([disabled])") || btns[0];
    if (first) choose(first);
  });

  /* ---- PDP gallery thumbs ---- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-main] img");
    g.querySelectorAll(".pdp__thumbs button").forEach(function (b) {
      b.addEventListener("click", function () {
        g.querySelectorAll(".pdp__thumbs button").forEach(function (x) { x.setAttribute("aria-selected", "false"); });
        b.setAttribute("aria-selected", "true");
        if (main) { main.src = b.querySelector("img").src; main.alt = b.querySelector("img").alt; }
      });
    });
  });

  /* ---- cart qty (preview maths only) ---- */
  var cart = document.querySelector("[data-cart]");
  if (cart) {
    var recalc = function () {
      var sub = 0;
      cart.querySelectorAll(".line").forEach(function (l) {
        var q = parseInt(l.querySelector(".qty span").textContent, 10);
        var p = parseFloat(l.dataset.price);
        sub += q * p;
        l.querySelector("[data-lt]").textContent = "$" + (q * p).toFixed(2);
      });
      var subEl = cart.querySelector("[data-sub]"), totEl = cart.querySelector("[data-tot]");
      if (subEl) subEl.textContent = "$" + sub.toFixed(2);
      if (totEl) totEl.textContent = "$" + sub.toFixed(2);
      var n = 0;
      cart.querySelectorAll(".qty span").forEach(function (s) { n += parseInt(s.textContent, 10); });
      document.querySelectorAll("[data-count]").forEach(function (c) { c.textContent = n; });
    };
    cart.querySelectorAll(".qty").forEach(function (q) {
      var span = q.querySelector("span");
      q.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () {
          var v = parseInt(span.textContent, 10) + (b.dataset.d === "+" ? 1 : -1);
          span.textContent = Math.max(1, v);
          recalc();
        });
      });
    });
    recalc();
  }

  /* ---- newsletter (preview: no real submit) ---- */
  document.querySelectorAll("[data-nl]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var i = f.querySelector("input");
      f.innerHTML = '<p style="margin:0;font-family:var(--display);font-size:21px">Thanks — your guide is on the way to ' +
        (i ? i.value.replace(/[<>&"]/g, "") : "you") + ".</p>";
    });
  });

  /* ---- contact form (preview: no real submit; maps to Shopify contact form on port) ---- */
  document.querySelectorAll("[data-cform]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var ok = f.querySelector("[data-cform-ok]");
      if (ok) ok.classList.add("on");
      f.querySelectorAll("input,textarea").forEach(function (el) { el.value = ""; });
    });
  });
})();

/* ---- 24-can subscription mix builder ---- */
(function () {
  var mx = document.querySelector("[data-mixer]");
  if (!mx) return;
  var TOTAL = parseInt(mx.dataset.total, 10) || 24;
  var rows = [].slice.call(mx.querySelectorAll("[data-flavor]"));
  var bar = mx.querySelector("[data-mix-bar]");
  var countEl = mx.querySelector("[data-mix-count]");
  var noteEl = mx.querySelector("[data-mix-note]");
  var recap = mx.querySelector("[data-mix-recap]");
  var recapTxt = mx.querySelector("[data-mix-summary-text]");
  var fSummary = mx.querySelector("[data-mix-summary]");
  var fJson = mx.querySelector("[data-mix-json]");
  var atc = document.querySelector("[data-atc]");
  var qty = {};
  rows.forEach(function (r) { qty[r.dataset.key] = 0; });

  function sum() {
    return rows.reduce(function (n, r) { return n + qty[r.dataset.key]; }, 0);
  }
  function render() {
    var t = sum(), left = TOTAL - t, full = t === TOTAL;
    rows.forEach(function (r) {
      var k = r.dataset.key, v = qty[k];
      r.querySelector("[data-qty]").textContent = v;
      r.classList.toggle("is-on", v > 0);
      r.querySelector('[data-step="-1"]').disabled = v === 0;
      r.querySelector('[data-step="1"]').disabled = left === 0;
    });
    bar.style.width = (t / TOTAL * 100) + "%";
    countEl.textContent = t;
    mx.classList.toggle("is-full", full);
    noteEl.textContent = full
      ? "Your box is complete — 24 cans, exactly how you want them."
      : (t === 0 ? "Choose 24 cans across any of our flavors."
                 : left + (left === 1 ? " can left to choose." : " cans left to choose."));
    var picked = rows.filter(function (r) { return qty[r.dataset.key] > 0; });
    var summary = picked.map(function (r) {
      return r.dataset.name + " \u00d7 " + qty[r.dataset.key];
    }).join(" \u00b7 ");
    fSummary.value = full ? summary : "";
    fJson.value = full ? JSON.stringify(rows.reduce(function (o, r) {
      if (qty[r.dataset.key]) o[r.dataset.key] = qty[r.dataset.key];
      return o;
    }, {})) : "";
    if (recap) {
      recap.hidden = !picked.length;
      if (recapTxt) recapTxt.textContent = summary;
    }
    if (atc) {
      atc.classList.toggle("is-locked", !full);
      atc.disabled = !full;
      atc.textContent = full ? "Add subscription to cart" : "Pick " + left + " more " + (left === 1 ? "can" : "cans");
    }
  }
  mx.addEventListener("click", function (e) {
    var step = e.target.closest("[data-step]");
    if (step) {
      var row = step.closest("[data-flavor]"), k = row.dataset.key;
      var d = parseInt(step.dataset.step, 10);
      var next = qty[k] + d;
      if (next < 0 || sum() + d > TOTAL) return;
      qty[k] = next;
      render();
      return;
    }
    var pre = e.target.closest("[data-preset]");
    if (!pre) return;
    if (pre.dataset.preset === "clear") {
      rows.forEach(function (r) { qty[r.dataset.key] = 0; });
    } else {
      var n = rows.length, base = Math.floor(TOTAL / n), rem = TOTAL % n;
      rows.forEach(function (r, i) { qty[r.dataset.key] = base + (i < rem ? 1 : 0); });
    }
    render();
  });
  render();
})();

/* ---- seasonal notify-me capture (preview stub) ---- */
document.querySelectorAll("[data-notify]").forEach(function (f) {
  f.addEventListener("submit", function (e) {
    e.preventDefault();
    var ok = f.parentElement.querySelector("[data-notify-ok]");
    f.hidden = true;
    if (ok) ok.hidden = false;
  });
});
